export default (() => {
  $(document).ready(function(){
    $('#gdpr').find('.button').click(function(){
      setCookie('cookie_aggrement', '1', 5);
      $('#gdpr').hide();
    });

    if ( getCookie('cookie_aggrement') != '' )
    {
      $('#gdpr').hide();
    }
  });

  //Cookies Functions
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }
  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  //END - Cookies Functions
});


// WEBPACK FOOTER //
// ./scripts/components/cookie-warning.js